<template>
    <LoadingCard v-if="loading" />
    <div v-else>
        <div class="card">
            <div class="card-header bg-primary text-white">
                Orchard Maps
            </div>
            <b-table small hover stacked="md" :items="filteredData" :fields="table.fields" :show-empty="true">
                <template slot="name" slot-scope="row">
                    <span class="text-nowrap">{{ row.item.name }}</span>
                </template>

                <template slot="actions" slot-scope="row">

                    <a :href="row.item.image" :download="buildFileName(row.item)" v-b-tooltip="'Click to download map'" target="_blank">
                        <img :src="row.item.image" class="img-fluid">
                    </a>
                </template>
            </b-table>
        </div>
    </div>
</template>
<script>
import listOrchardMapsQuery from '@views/Setup/OrchardMapManager/queryListOrchardMaps.graphql';

/**
 * @property {String} searchTerm
 */
export default {
  name: 'ContractorOrchardMapBrowse',
  props: ['growerId'],
  apollo: {
    orchardMaps: {
      query: listOrchardMapsQuery,
      update: data => data.filterOrchardMaps.data,
      variables() {
        return {
          input: {
            user_id: this.growerId,
          },
        };
      },
    },
  },
  data() {
    return {
      orchardMaps: [],
      loading: 0,
    };
  },
  computed: {
    table() {
      return {
        fields: [
          { key: 'name', label: 'Name' },
          { key: 'actions', label: '', class: 'text-right' },
        ],
      };
    },
    filteredData() {
      return this.orchardMaps.filter(subject => Boolean(subject.image)).sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  mounted() {
  },
  methods: {
    buildFileName(item) {
      if (item.image) {
        const extension = item.image.substr(item.image.lastIndexOf('.'));
        return `${item.name}${extension}`;
      }
    },
  },
};
</script>
